module.exports = __webpack_public_path__ + "media/images/icon-facebook-09e800b068517836ec9d4313164a11e2.svg";